import { useRef, useState, Fragment, useEffect } from 'react';

import ProjectRowData from './projectRowData';
import ActionModal from './Modals/actionModal';
import Pagination from './Pagination/pagination';
import ResponseNotification from './Modals/responseNotification';

import { Auth } from "../../../Common/lib/auth";
import { API } from "../../../Common/lib/api";
import { searchProjects } from '../../../graphql/queries';

const projects = [
    {
        id: 1,
        name: "Backscatter Data of Great Slave Lake Power Cable Survey",
        owner: "Chance Dorwart",
        email: "chance@example.com",
        date: "05/01/2023",
    },
    {
        id: 2,
        name: "Coastline Data of Great Slave Lake Power Cable Survey",
        owner: "Kierra Schleifer",
        email: "kierra@example.com",
        date: "02/01/2023",
    },
    {
        id: 3,
        name: "Coastline Route Subbottom Profiles data of Great Slave Lake Power Cable Survey",
        owner: "Carter Vetrovs",
        email: "carter@example.com",
        date: "22/12/2023",
    },
    {
        id: 4,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 5,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 6,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 7,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 8,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 9,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 10,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 11,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 12,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 13,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 14,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 15,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 16,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 17,
        name: "Backscatter Data of Great Slave Lake Power Cable Survey",
        owner: "Chance Dorwart",
        email: "chance@example.com",
        date: "05/01/2023",
    },
    {
        id: 18,
        name: "Coastline Data of Great Slave Lake Power Cable Survey",
        owner: "Kierra Schleifer",
        email: "kierra@example.com",
        date: "02/01/2023",
    },
    {
        id: 19,
        name: "Coastline Route Subbottom Profiles data of Great Slave Lake Power Cable Survey",
        owner: "Carter Vetrovs",
        email: "carter@example.com",
        date: "22/12/2023",
    },
    {
        id: 20,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 21,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 22,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 23,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 24,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 25,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 26,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 27,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 28,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 29,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 30,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
    {
        id: 31,
        name: "Ecosystem Plot data for Victoria Island and adjacent mainland  Nunavut 2013-2014",
        owner: "Alredo Vetrovs",
        email: "alfredo@example.com",
        date: "20/12/2023",
    },
    {
        id: 32,
        name: "GREAT SLAVE LAKE BATHYMETRIC SURVEY",
        owner: "Dulce George",
        email: "dulce@example.com",
        date: "18/12/2023",
    },
];

/**
 * Returns the Admin File Approval List component.
 * 
 * @returns The Admin File Approval List component.
 */
const FileApprovalList = () => {
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const [isApprove, setIsApprove] = useState(null);
    const [selectedProject, setSelectedProject] = useState([]);

    const cancelButtonRef = useRef(null);

    /**
    * Checks if the user is currently logged in and returns the right authentication mode to be used for GraphQL queries.
    * 
    * @returns 'AMAZON_COGNITO_USER_POOLS' when the user is logged in. 'AWS_IAM' when the user is not logged in.
    */
    async function getAuthMode() {
        try {
            await Auth.currentAuthenticatedUser();
            return 'AMAZON_COGNITO_USER_POOLS';
        } catch {
            return 'AWS_IAM';
        }
    }


    ///
    const [currentPage, setCurrentPage] = useState(1);
    const projectsPerPage = 3;

    const indexOfLastProject = currentPage * projectsPerPage;
    const indexOfFirstProject = indexOfLastProject - projectsPerPage;
    const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);
  
    // const paginate = (pageNumber) => setCurrentPage(pageNumber);
    ///








    const FileApproval = (project) => {
        setOpen(true);
        setSelectedProject(project);
    };

    const [listProject, setProjects] = useState([]);

    useEffect(() => {
        setTimeout(() => {
            const html = document.body.parentNode;

            if (html) {
                html.classList.add('modal_close');
            }
        }, 50);
    }, [open]);

    useEffect(() => {
        try {
            //Must get Authentication Mode before calling the API. 
            getAuthMode().then(async (authMode) => {
                const projectsQuery = await API.graphql({
                    query: searchProjects,
                    variables: { from: (1 * 8), limit: 8 },
                    authMode: authMode,
                });
      
                setProjects(projectsQuery.data.searchProjects.items);
                // props.setProjectCount(projectsQuery.data.searchProjects.total);
            })
        } catch (e) {
            // console.log(e);
        }
    }, [])
    

    return (
        <>
            <ActionModal
                show={open}
                as={Fragment}
                onClose={setOpen}
                setShow={setShow}
                setOpen={setOpen}
                setIsApprove={setIsApprove}
                initialFocus={cancelButtonRef}
                selectedProject={selectedProject}
                cancelButtonRef={cancelButtonRef}
            />

            <div className="my-auto md:m-auto md:w-full lg:w-11/12 xl:w-10/12 relative">
                <ResponseNotification
                    show={show}
                    as={Fragment}
                    setShow={setShow}
                    isApprove={isApprove}
                />

                <div className="py-6 px-3 w-full md:px-5 md:py-12 bg-gray-200 md:w-full lg:rounded-lg xl:p-12 drop-shadow-2xl">
                    <header className="md:w-full">
                        <h1 className="text-3xl py-2 font-black leading-tight text-gray-900">Large File Approval</h1>
                    </header>

                    <main className="mt-8 overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:mx-0 md:rounded-lg">
                        <Pagination
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            projectCount={currentProjects.length}
                        />

                        <table className="w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                        Name
                                    </th>

                                    <th
                                        scope="col"
                                        className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                                    >
                                        User
                                    </th>

                                    <th
                                        scope="col"
                                        className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                                    >
                                        Email
                                    </th>

                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Date
                                    </th>

                                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                        <span className="sr-only">Action</span>
                                    </th>
                                </tr>
                            </thead>
                            
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {currentProjects.map((project) => (
                                    <ProjectRowData
                                        key={project.id}
                                        project={project}
                                        setShow={setShow}
                                        fileApproval={FileApproval}
                                    />
                                ))}
                            </tbody>
                        </table>

                        <Pagination
                            currentPage={currentPage}
                            projectCount={currentProjects.length}
                            setCurrentPage={setCurrentPage}
                        />

                        {/* <Pagination
                            paginate={paginate}
                            projectCount={projectCount}
                            currentPage={currentPage}
                        /> */}
                    </main>
                </div>
            </div>
        </>
    );
};
 
export default FileApprovalList;